import { render } from "./ChannelListNon.vue?vue&type=template&id=1a82273c&scoped=true&ts=true"
import script from "./ChannelListNon.vue?vue&type=script&lang=ts"
export * from "./ChannelListNon.vue?vue&type=script&lang=ts"

import "./ChannelListNon.vue?vue&type=style&index=0&id=1a82273c&scoped=true&lang=css"

import exportComponent from "/home/runner/work/angelleague-front/angelleague-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a82273c"]])

export default __exports__